import { render, staticRenderFns } from "./ProductListTable.vue?vue&type=template&id=483aa28b&scoped=true&lang=html"
import script from "./ProductListTable.vue?vue&type=script&lang=js"
export * from "./ProductListTable.vue?vue&type=script&lang=js"
import style0 from "./ProductListTable.vue?vue&type=style&index=0&id=483aa28b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483aa28b",
  null
  
)

export default component.exports